module.exports = __webpack_public_path__ + "./img/PI-icon.svg";